import { useContext, useEffect, useState } from 'react'
import { PromotedBranchContext } from './context/context'
import { NavContext } from '../../context/global_context'
import { useNavigate } from 'react-router-dom'
import { deleteRequest, getRequest, postRequest } from '../../services/base'
import Button from '../common/Button'
import InputText from '../common/InputText'
import SelectMakeModelModal from './select_make_model_modal'
import SelectFileToPromote from './select_file_to_promote_modal'
import PreviewPromotedFiles from './preview_promoted_files'
import NoRecordsFound from '../common/NoRecordsFound'
import { ProgresSpinner } from '../common/ProgresSpinner'
import useDebouncedValue from '../../utils/common_function'
import {
  DELETE_PROMOTED_FILES,
  PROMOTE_CHANGES,
  TRACER_PREVIEW,
  TRACER_PREVIEW_MGMT,
} from '../../constants/permission'
import { FileJson, Flag } from '@styled-icons/boxicons-solid'
import { downloadFileBlob } from '../../utils/common'
import { toString } from '../../utils/json'
import { CodeMerge } from '@styled-icons/fa-solid'
import DownloadDeleteFileLogBtn from './delete_files/download_logs_btn'
import DropDownMenu from '../common/DropDownMenu'
import { ListCheck, Menu } from '@styled-icons/boxicons-regular'
import LinkWithStatus from '../common/LinkWithStatus'
import { useThemeContext } from '../../context/theme_context'
import { DARK_MODE } from '../../constants'

const DEFAULT_MENU = [
  {
    name: 'Data Updates Json',
    value: `data_updates_json`,
    href: `/manage-update-list/updates/json`,
    icon: <FileJson size="1rem" />,
  },
  {
    name: 'Data Updates List',
    value: `updates_list`,
    href: `/manage-update-list/updates/list`,
    icon: <ListCheck size="1rem" />,
  },
]

const PromoteChanges = () => {
  const navigate = useNavigate()

  const [state, dispatch] = useContext(PromotedBranchContext)
  const [navState, navDispatch] = useContext(NavContext)

  const [searchValue, setSearchValue] = useState(null)

  const [selectedRow, setSelectedRow] = useState(null)
  const [filteredVehicles, setFilteredVehicles] = useState([])
  const debouncedToSearchValue = useDebouncedValue(searchValue, 500)
  const [menuOptions, setMenuOptions] = useState([])
  const { mode } = useThemeContext()

  useEffect(() => {
    getActiveBranchDetails(true)
  }, [])

  useEffect(() => {
    if (state?.data?.vehicles?.length > 0) {
      if (searchValue) {
        setFilteredVehicles([
          ...state?.data?.vehicles.filter((item) =>
            item.name.toLowerCase().includes(searchValue.toLowerCase())
          ),
        ])
      } else {
        setFilteredVehicles([...state?.data?.vehicles])
      }
    } else {
      setFilteredVehicles([])
    }
  }, [debouncedToSearchValue])

  const getActiveBranchDetails = async (showLoader = false) => {
    if (showLoader) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Loading Promoted Branch Data ...',
          showLoader: true,
        },
        notification: {},
      })
    }

    let res = await getRequest(`/api/promote_changes/active_branch/`)
    dispatch({ type: 'set_promoted_branch_data', data: res.data })
    setFilteredVehicles(res?.data?.vehicles)
    navDispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
    if (res?.data?.is_processing) {
      setTimeout(() => {
        getActiveBranchDetails(false)
      }, 60000)
    }
  }

  const closeOpenSelectedSection = (value, valueIdx) => {
    if (selectedRow?.idx === valueIdx) {
      setSelectedRow({})
    } else {
      setSelectedRow({ value: value, idx: valueIdx })
    }
  }

  const deleteCurrentBranch = async (branch_name) => {
    if (
      window.confirm(
        `Are you sure want to delete ${branch_name}, It will delete branch from git also it will delete meta data !`
      ) === true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Deletion of branch in progress ...',
          showLoader: true,
        },
        notification: {},
      })

      let res = await deleteRequest(`/api/promote_changes/delete/branch/`)
      if (res?.data) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Branch Deleted successfully from git.',
          },
        })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'info',
            msg: 'Branch Deleted successfully',
          },
        })
      }
      setTimeout(() => {
        window.location.reload()
      }, 500)
    }
  }

  const downloadUpdateJson = () => {
    if (state?.data?.vehicles?.length > 0) {
      let tempVehicleData = state?.data?.vehicles
        .filter((vehicle_obj) => vehicle_obj?.git_status === 'success')
        .map((vehicle_obj) => {
          return {
            model_dir: vehicle_obj.vehicle_id,
            make_model_id: vehicle_obj.make_model_id,
          }
        })
      if (tempVehicleData?.length > 0) {
        var fileToSave = new Blob([toString(tempVehicleData)], {
          type: 'application/json',
        })
        downloadFileBlob(fileToSave, 'tracer-data_updates.json')
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: 'No vehicle promoted till now.',
          },
        })
      }
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: 'No vehicle promoted till now.',
        },
      })
    }
  }

  const syncToGit = async (vehicle_id) => {
    if (
      window.confirm(
        `Are you sure want to re start git hub sync for existing uploaded files for make model ${vehicle_id}?`
      ) === true
    ) {
      let res = await postRequest(
        `/api/promote_changes/git/start/${vehicle_id}/`
      )
      if (res?.status) {
        getActiveBranchDetails(false)

        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Git syncing successfully started',
          },
        })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: 'Something went wrong.',
          },
        })
      }
    }
  }

  const showPromoteChangeMenu = () => {
    let tempMenu = []
    DEFAULT_MENU.map((menu, menuIdx) => {
      if (state?.data?.vehicles?.length > 0) {
        tempMenu.push(menu)
      }
    })
    setMenuOptions(tempMenu)
  }

  const downloadUpdateCSV = async () => {
    if (
      window.confirm(
        `Are you sure want to download updates list for ${state?.data?.branch?.name}`
      ) === true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Download updates is in progress ...',
          showLoader: true,
        },
        notification: {},
      })
      let res = await getRequest(
        `/api/promote_changes/download/updates/csv/`,
        true,
        true
      )
      if (res?.msg) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      } else {
        downloadFileBlob(
          res,
          `summary-updates-${state?.data?.branch?.name}.csv`
        )
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Request File successfully downloaded.',
          },
        })
      }
    }
  }

  return (
    <>
      {state?.showVehicleModal && <SelectMakeModelModal />}

      {state?.showFileSelection && (
        <SelectFileToPromote getActiveBranchDetails={getActiveBranchDetails} />
      )}

      <div
        className="flex flex-col py-3 space-y-6 w-full text-black"
        style={{ padding: '16px 12%' }}
      >
        <div className="font-light">
          <div className="flex flex-row w-full font-medium items-center justify-between gap-2">
            <div
              className={`text-l w-full items-center flex ${mode === DARK_MODE ? 'text-white' : 'text-black'}`}
            >
              <div>Github Branch :- {state?.data?.branch?.name} </div>
              {navState?.permissions?.includes(TRACER_PREVIEW_MGMT) && (
                <CodeMerge
                  size="2rem"
                  onClick={() => {
                    deleteCurrentBranch(state?.data?.branch?.name)
                  }}
                  className="px-1 mx-2 cursor-pointer"
                />
              )}
            </div>

            <div className="flex flex-row items-center w-full">
              <InputText
                name="search_value"
                placeholder={`Search Make Model`}
                className={`w-full`}
                value={searchValue}
                isFullSize={true}
                type="search"
                onChange={(value) => {
                  setSearchValue(value)
                }}
                isRequired={false}
                wrapperClass={`pl-0`}
              />
            </div>
            {navState?.permissions?.includes(PROMOTE_CHANGES) && (
              <Button
                type="submit"
                className={`cursor-pointer btn`}
                text={'Select Vehicles'}
                onClick={() => {
                  dispatch({ type: 'show_hide_vehicle_popup', data: true })
                }}
              />
            )}
            {state?.data?.remote_branch_exits &&
              (navState?.permissions?.includes(TRACER_PREVIEW) ||
                navState?.permissions?.includes(TRACER_PREVIEW_MGMT)) && (
                <Button
                  type="submit"
                  className={`cursor-pointer btn`}
                  text={'Launch Tracer Preview'}
                  onClick={() => {
                    navigate('/manage-update-list/preview')
                  }}
                />
              )}
            <DropDownMenu
              items={menuOptions}
              outsideClickClose={true}
              onClick={(menu_item) => {
                if (menu_item?.value === 'data_updates_json') {
                  downloadUpdateJson()
                } else if (menu_item?.value === 'updates_list') {
                  downloadUpdateCSV()
                }
              }}
            >
              <LinkWithStatus
                href={`/vehicles/manage-update-list/edit`}
                className="btn"
                title="Promote Change Menu"
                onClickFunc={() => {
                  showPromoteChangeMenu()
                }}
              >
                <Menu size="1.5rem" color="white" />
              </LinkWithStatus>
            </DropDownMenu>
          </div>

          <div className="py-2">
            <div className="flex flex-row bg-tracer-lt-blue rounded-t text-white px-3 text-sm font-light">
              <div className="px-2">Vehicle</div>
            </div>
            <div className="font-light new" style={{height: 'calc(100vh - 158px)',
    overflowY: 'auto'}}>
              {filteredVehicles?.length == 0 && <NoRecordsFound />}
              {filteredVehicles?.map((vehicle, valueIdx) => {
                return (
                  <div
                    key={`promote-changes-${valueIdx}`}
                    className="flex flex-row items-center bg-white py-2 px-3 border-b border-tracer-dark-blue"
                  >
                    <div className="w-full">
                      <div className="flex flex-row w-full items-center bg-white text-sm justify-between py-1 px-2">
                        <div className="font-medium text-xl">
                          {vehicle.name} ({vehicle.make_model_id})
                        </div>
                        <div className="flex flex-row gap-3 items-center">
                          {vehicle?.is_processing ? (
                            <ProgresSpinner
                              caption={`Files syncing in progress`}
                            />
                          ) : (
                            <>
                              {navState?.permissions?.includes(
                                DELETE_PROMOTED_FILES
                              ) && (
                                <>
                                  <div
                                    className="underline cursor-pointer"
                                    onClick={() => {
                                      navigate(
                                        `/manage-update-list/${state?.data?.branch?.name}/${vehicle.vehicle_id}/delete`
                                      )
                                    }}
                                  >
                                    Delete Files
                                  </div>
                                  {vehicle?.is_delete_exists && (
                                    <DownloadDeleteFileLogBtn
                                      isBtn={false}
                                      vehicle={vehicle.vehicle_id}
                                    />
                                  )}
                                </>
                              )}

                              <div
                                className="underline cursor-pointer"
                                onClick={() => {
                                  closeOpenSelectedSection(vehicle, valueIdx)
                                }}
                              >
                                {selectedRow?.idx !== valueIdx
                                  ? `See Promoted Files`
                                  : `Close`}
                              </div>
                              <div
                                className="underline cursor-pointer text-blue-600"
                                onClick={() => {
                                  dispatch({
                                    type: 'show_hide_file_selection_popup',
                                    data: true,
                                    selectedVehicle: vehicle,
                                    showVehicleModal: false,
                                    selectedFiles: [],
                                  })
                                  setSelectedRow({})
                                }}
                              >
                                Manage File List
                              </div>
                              {vehicle?.git_status === 'success' && (
                                <Flag size="2rem" color="green" />
                              )}
                              {vehicle?.git_status === 'failure' && (
                                <Flag
                                  size="2rem"
                                  color="red"
                                  className="cursor-pointer"
                                  onClick={() => {
                                    syncToGit(vehicle.vehicle_id)
                                  }}
                                />
                              )}
                              {vehicle?.git_status === 'cancelled' && (
                                <Flag size="2rem" color="gray" />
                              )}
                            </>
                          )}
                        </div>
                      </div>
                      {selectedRow?.idx === valueIdx && (
                        <PreviewPromotedFiles selectedRow={selectedRow} />
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PromoteChanges
